import { createFileRoute } from '@tanstack/react-router';

import { ProjectView } from '@/features/projects/projects';

export const Route = createFileRoute('/_authenticated/projects/$projectId')({
  component: ProjectRoute,
});

function ProjectRoute() {
  const { projectId } = Route.useParams();
  return <ProjectView key={projectId} projectId={projectId} />;
}
